import { React } from 'react';

import CalculateRoundedIcon from '@mui/icons-material/CalculateRounded';

import AgreementWorkflowPage from '../../components/agreementWorkflowPage';

const SimularAcordo = () => {
    return (
        <AgreementWorkflowPage
            title='Simular Acordo'
            formId='formSimularAcordo'
            introTitle='Simulação de acordo financeiro'
            introText='Consulte as contas do cliente e projete as condições de entrada, parcelas e primeiro vencimento antes de gerar a negociação definitiva.'
            submitEndpoint='simularAcordo'
            submitLabel='Simular Acordo'
            submitIcon={<CalculateRoundedIcon />}
            summaryTitle='Prévia da simulação'
            attentionText='A simulação calcula as condições para as contas selecionadas sem efetivar lançamentos. Use o resultado para revisar a proposta antes do lançamento.'
            getSummaryItems={({ documento, selectedBillsCount, rows, selectedBillsTotalLabel, parcelas, dueDateLabel, dateTime }) => [
                { label: 'CPF/CNPJ', value: documento || 'Não informado', empty: !documento },
                {
                    label: 'Contas selecionadas',
                    value: `${selectedBillsCount} de ${rows.length}`,
                    empty: selectedBillsCount === 0
                },
                {
                    label: 'Valor selecionado',
                    value: selectedBillsTotalLabel,
                    empty: selectedBillsCount === 0
                },
                { label: 'Operação', value: 'Simulação' },
                {
                    label: 'Parcelamento',
                    value: `${parcelas || 0} parcela${Number(parcelas) === 1 ? '' : 's'}`
                },
                { label: 'Primeiro vencimento', value: dueDateLabel, empty: !dateTime }
            ]}
        />
    );
};

export default SimularAcordo;
